import React from 'react';
import PropTypes from 'prop-types';
import Gluehbirne from '@images/svg/how-it-works/01-gluehbirne.svg';

const IdeaCard = ({ animationOffset, idea, onOpen }) => {
  return (
    <div className='c-idea-card' style={{ animationDelay: `${animationOffset * 250 + 200}ms` }}>
      <button
        key={idea.id}
        title={idea.title.rendered}
        className='c-idea-card__card'
        onClick={onOpen}
      >
        {idea.thumbnail ? (
          <img
            className='c-idea-card__image'
            src={idea.thumbnail?.idea_tile_1x}
            srcSet={`${idea.thumbnail?.idea_tile_1x} 1x, ${idea.thumbnail?.idea_tile_2x} 2x`}
            alt={idea.title.rendered}
          />
        ) : (
          <div className='c-idea-card__image-placeholder'>
            <Gluehbirne />
          </div>
        )}
        <h4 className='u-text-white'>{idea.title.rendered}</h4>
        <p className='c-idea-card__meta'>
          {`${idea.acf.firstname} ${idea.acf.lastname}`}
          {idea.acf.region_or_place ? ` aus ${idea.acf.region_or_place}` : null}
        </p>
      </button>
    </div>
  );
};

IdeaCard.propTypes = {
  animationOffset: PropTypes.number.isRequired,
  idea: PropTypes.object.isRequired,
  onOpen: PropTypes.func.isRequired
};

export default IdeaCard;
